import { useServiceLetterContext } from '../hooks/useServiceLetterContext';
import '../styles/Header.css';

export const Header = () => {
    const { state } = useServiceLetterContext();

    if (state.serviceLetters.length === 0) {
        return null;
    }

    return (
        <header className="sl-header">
            <div className="sl-header-overlay"></div>
            <section className="sl-header-content">
                <div className="sl-header-text-container">
                    <h2 className="sl-header-heading-title-top">Unidades</h2>
                </div>
                <div className="sl-header-text-container">
                    <h2 className="sl-header-heading-title-bottom">
                        {state.serviceLetters[0] &&
                            state.serviceLetters[0].project}
                    </h2>
                </div>
            </section>
        </header>
    );
};
